import React, { useEffect, useState } from "react";
import { commentConditionPostApi } from "../../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import Button from "../../../Button/Button";
import Style from "./CommentCondition.module.scss";
const CommentCondition = ({ handleOk, rawInfo, statusIs, getAllComment }) => {
  const [describ, setDescrib] = useState();
  const [disable, setDisable] = useState(false);
  const sendInfo = () => {
    setDisable(true);
    let info = {
      id: rawInfo.commentId,
      status: statusIs,
      cause: describ,
    };
    commentConditionPostApi(info, (suc) => {
      if (suc.status === 1) {
        succToast(suc.message);
        setDisable(false);
      } else {
        errorToast(suc.message);
        setDisable(false);
      }
    });
    getAllComment();
    handleOk();
  };

  return (
    <div className={Style.componentHolder}>
      <label className={Style.reasonTarget} htmlFor="reason">
        ذکر دلیل
      </label>
      <textarea
        value={describ}
        onChange={(e) => setDescrib(e.target.value)}
        className={Style.description}
        id={"reason"}
      />
      <div className={Style.btnHolder}>
        <Button ClickHandler={sendInfo} Value="ارسال" ClassBtn="sendBtn" disabledprops={disable}/>
        <Button ClickHandler={handleOk} Value="بستن" ClassBtn="okBtn" />
      </div>
    </div>
  );
};

export default CommentCondition;
